import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { ErrorScreen } from "@lending/components/ErrorScreen/ErrorScreen";
import { guardBackForwardCache } from "@lending/lib/backForwardCache";
import { defaultQueryClient } from "@lending/lib/queryConfig";
import App from "./App.tsx";

// import global styles
import "@narmi/design_system/dist/style.css";
import "cerulean/styles.scss";

const root = createRoot(document.getElementById("root")!);

guardBackForwardCache(() => {
  root.unmount();
  defaultQueryClient.clear();
});

root.render(
  <div className="nds-typography">
    <Sentry.ErrorBoundary fallback={<ErrorScreen />}>
      <StrictMode>
        <App />
      </StrictMode>
    </Sentry.ErrorBoundary>
  </div>
);
